import React, { useState, useEffect } from "react";
import { Button, Text } from "components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import CommonCustomerGet from "components/CommonServiceComponent/CommonCustomerGet";
import CommonSupplierGet from "components/CommonServiceComponent/CommonSupplierGet";

function DelivaryChallanAdd() {
  const [visible, setvisible] = useState(true);
  const [customerList, setCustomerList] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [supplierId, setsupplierId] = useState(null);
  const [CompanyPurchase, setCompanyPurchase] = useState([]);
  const [searchInput, setSearchInput] = useState(""); // State to store search input
  const [customerId, setCustomerId] = useState([]);
  const [subcontractorList, setSubcontractorList] = useState([]);
  const [delivaryChallanTypeList, setdelivaryChallanTypeList] = useState([]);
  const [selectedRedioType, setSelectedRadioType] = useState();
  const [resetCodeKey, setResetCodeKey] = useState(0);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  let navigate = useNavigate();

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const [erplist, setErplist] = useState([]);

  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");
    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showActionColumn = erplist.some(
    (item) => item.erp_module_id === 51 && item.add
  );

  useEffect(() => {
    getDeliverychallanTypeLists();
  }, []);

  // const validationSchema = Yup.object().shape({
  //   customer_id: Yup.string().required(" Customer is required"),
  //   delivery_challan_type_id: Yup.string().required(
  //     "Delivery challan  is required "
  //   ),
  //   remark: Yup.string().required("Remark  is required "),
  // });
  const validationSchema = Yup.object().shape({
    customer_id: Yup.string().required("Customer is required"),
    delivery_challan_type_id: Yup.string().required(
      "Delivery challan is required"
    ),
    remark: Yup.string().required("Remark is required"),

    supplier_id: Yup.string().when("delivery_challan_type_id", {
      is: "5", // check string "5" (since formik values are strings by default)
      then: (schema) => schema.required("Supplier is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    company_purchase_order_id: Yup.string().when(
      "delivery_challan_type_id",
      {
        is: "5",
        then: (schema) =>
          schema.required("Company Purchase Order Type is required"),
        otherwise: (schema) => schema.notRequired(),
      }
    ),
  });

  const formik = useFormik({
    initialValues: {
      customer_id: "",
      delivery_challan_type_id: "",
      remark: "",
      supplier_id: "",
      company_purchase_order_id: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  useEffect(() => {
    CompanyPurchaseget();
  }, [formik.values.supplier_id]);

  const CompanyPurchase_obj = {
    supplier_id: formik.values.supplier_id,
    company_purchase_order_status_id: 1,
  };

  const CompanyPurchaseget = () => {
    axios
      .post(
        "/api/purple-fusion/stocktransaction/get/companypurchaseorder",
        CompanyPurchase_obj,
        headers
      )
      .then((response) => {
        const filterdata= response.data.filter((item)=>item.company_purchase_order_type_id===10 )
        setCompanyPurchase(filterdata);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const sortedCompanyPurchesOrder = CompanyPurchase.slice().sort(
    (a, b) => b.id - a.id
  );

  useEffect(() => {
    setCompanyPurchase((prevItems) =>
      prevItems.map((item) => ({ ...item, checked: false }))
    );

    setSelectAllChecked(false);
    setResetCodeKey((prevKey) => prevKey + 1);
  }, [formik.values.supplier_id]);

  const deliverychallantype = {};
  const getDeliverychallanTypeLists = () => {
    axios
      .post(
        "/api/purple-fusion/delivarychallantype/get",
        deliverychallantype,
        headers
      )
      .then((res) => {
        setdelivaryChallanTypeList(res.data);
        console.log(res.data);
      });
  };

  const handleFormSubmit = (values) => {
    console.log(values);
    axios
      .post("/api/purple-fusion/delivarychallan/create", values, headers)
      .then((response) => {
        // console.log(requestData);
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setvisible(false);
                // navigate("/delivarychallan/list");
                navigate(
                  // `/delivarychallanitem/add/${response.data.id}/${formik.values.delivery_challan_type_id}/${formik.values.customer_id}`
                   Number(formik.values.delivery_challan_type_id) === 5
                      ? `/delivarychallanitem/jobwork/add/${response.data.id}/${formik.values.delivery_challan_type_id}/${formik.values.customer_id}`
                      : `/delivarychallanitem/add/${response.data.id}/${formik.values.delivery_challan_type_id}/${formik.values.customer_id}`
                );
              },
            })
          : toast.error(message, {
              autoClose: 2000,
            });
      })
      .catch((error) => {
        console.log(error);
        setvisible(false);
        navigate("*");
      });
  };
  // const sortedItemList=itemList.slice().sort((a,b)=>( b.id - a.id ));
  const customStyle = {
    content: {
      width: "60%",
      height: "65%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };
  return (
    <div>
      {showActionColumn ? (
        <div>
          <Modal isOpen={visible} onRequestClose={() => {}} style={customStyle}>
            <form onSubmit={formik.handleSubmit}>
              <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
                <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                  <div className="flex flex-1 flex-col gap-[10px] justify-start md:px-5 w-full">
                    <div className="flex flex-row w-[100%]  ml-2">
                      <div className="flex flex-row sm:gap-15 items-center justify-start w-full ">
                        <Text
                          className="mt-[5px] text-base text-black-900 tracking-[0.20px] "
                          size="txtInterMedium24"
                        >
                          Add Delivary Challan
                        </Text>
                      </div>
                      <div className="flex flex-row items-center  justify-end  ">
                        <Button
                          className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px] active:scale-90 transition-transform duration-200"
                          shape="round"
                          color="blue_A700"
                          size="base"
                          variant="fill"
                          type="submit"
                        >
                          Save
                        </Button>
                        <Button
                          className="cursor-pointer sticky font-small mb-3 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                          shape="round"
                          color="white"
                          size="base"
                          variant="fill"
                          se
                          onClick={() => {
                            setvisible(false);
                            navigate(`/delivarychallan/list`);
                          }}
                        >
                          ╳
                        </Button>
                      </div>
                    </div>
                    <div className="flex flex-col items-center justify-start md:ml-[0] ml-[25px] w-[87%] md:w-full  ">
                      <ToastContainer />
                      <div className="flex flex-col items-center justify-start  w-full">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto "
                              size="txtInterMedium20Black900"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Customer Name
                              </span>
                              <span className="text-red-A700 font-inter font-small">
                                *
                              </span>
                            </Text>
                            <CommonCustomerGet
                              customerList={customerList}
                              setCustomerList={setCustomerList}
                              searchInput={searchInput}
                              setSearchInput={setSearchInput}
                              formik={formik}
                              setCustomerId={setCustomerId}
                            />
                            {formik.touched.customer_id &&
                            formik.errors.customer_id ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.customer_id}
                              </div>
                            ) : null}
                          </div>

                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto "
                              size="txtInterMedium20Black900"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Delivery Challan Type
                              </span>
                              <span className="text-red-A700 font-inter font-small">
                                *
                              </span>
                            </Text>

                            <Select
                              name="delivery_challan_type_id "
                              options={delivaryChallanTypeList.map(
                                (resstate) => ({
                                  label: resstate.name,
                                  value: resstate.id,
                                })
                              )}
                              className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full"
                              onChange={(selectedOption) => {
                                formik.setFieldValue(
                                  "delivery_challan_type_id",
                                  selectedOption.value
                                );
                                formik.setFieldValue("supplier_id", "");
                                formik.setFieldValue(
                                  "company_purchase_order_id",
                                  ""
                                );
                              }}
                              onBlur={formik.handleBlur}
                              placeholder="Select Delivary Challan Type"
                            />
                            {formik.touched.delivery_challan_type_id &&
                            formik.errors.delivery_challan_type_id ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.delivery_challan_type_id}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-start  w-full mt-8">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Remark
                              </span>
                              <span className="text-red-A700 font-inter font-small">
                                *
                              </span>
                            </Text>
                            <input
                              name="remark"
                              type="text"
                              placeholder=" Enter Remark"
                              onChange={(e) => {
                                formik.handleChange(e);
                              }}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                            {formik.touched.remark && formik.errors.remark ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.remark}
                              </div>
                            ) : null}
                          </div>
                          {formik.values.delivery_challan_type_id === 5 && (
                            <div className="flex flex-1 flex-col gap-[5px] items-start justify-start w-full mt-0">
                              <Text
                                className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                                size="txtInterMedium20Black700"
                              >
                                <span className="text-black-700 font-inter font-samll text-sm">
                                  Select Supplier
                                </span>
                                <span className="text-red-A700 font-inter font-samll text-sm">
                                  *
                                </span>
                              </Text>
                              <CommonSupplierGet
                                suppliers={suppliers}
                                setSuppliers={setSuppliers}
                                setSearchInput={setSearchInput}
                                setsupplierId={setsupplierId}
                                searchInput={searchInput}
                                formik={formik}
                              />
                              {formik.touched.supplier_id &&
                              formik.errors.supplier_id ? (
                                <div className="text-red-500 text-sm">
                                  {formik.errors.supplier_id}
                                </div>
                              ) : null}
                            </div>
                          )}
                        </div>
                      </div>
                      {formik.values.delivery_challan_type_id === 5 && (
                        <div className="flex flex-col items-center justify-start  w-full mt-8">
                          <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                            <div className="flex flex-1 flex-col gap-[5px] items-start justify-start w-full  mb-2">
                              <Text
                                className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                                size="txtInterMedium20Black700"
                              >
                                <span className="text-black-700 font-inter font-samll text-sm">
                                  Supplier purchase order Code
                                </span>
                                <span className="text-red-A700 font-inter font-samll text-sm">
                                  *
                                </span>
                              </Text>
                              <Select
                                name="company_purchase_order_type_id"
                                options={sortedCompanyPurchesOrder.map(
                                  (resstate) => ({
                                    label:
                                      resstate.code +
                                      " || " +
                                      resstate.company_purchase_order_type_name,
                                    value: resstate.code,
                                    company_purchase_order_id:
                                      resstate.id,
                                  })
                                )}
                                className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full"
                                onChange={(selectedOption) => {
                                  formik.setFieldValue(
                                    "company_purchase_order_id",
                                    selectedOption.company_purchase_order_id
                                  );
                                }}
                                key={resetCodeKey}
                                onBlur={formik.handleBlur}
                                placeholder="Select Code"
                              />
                              {formik.touched.company_purchase_order_id &&
                              formik.errors.company_purchase_order_id ? (
                                <div className="text-red-500 text-sm">
                                  {formik.errors.company_purchase_order_id}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Modal>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </div>
  );
}

export default DelivaryChallanAdd;
